<template>
	<div>
		<div class="fs4 fw7 lh125 mt6">Bank References</div>
		<j-accordion
			v-for="i in 2"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaBankReferenceList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="fs4 fw7 lh125 mt6">Other Financial Institutions</div>
		<j-accordion
			v-for="j in 1"
			:key="j"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ j }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaOtherList(j)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form class="mt6" :schema="schemaAuthorize" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaAuthorize() {
			return [
				{
					label: `金融机构联络人姓名`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0authorizedContactAtFinancialInstitutionCN`,
					props: {
						suggest: {
							typeIncludes: `authorizedContactAtFinancialInstitutionCN`
						},
						createOptions: {
							type: `authorizedContactAtFinancialInstitutionCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `金融机构名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0authorizedFinancialInstitutionNameCN`,
					props: {
						suggest: {
							typeIncludes: `authorizedFinancialInstitutionNameCN`
						},
						createOptions: {
							type: `authorizedFinancialInstitutionNameCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaBankReferenceList(i) {
			return [
				{
					label: `银行名称 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesName${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesName${i}CN`
						},
						createOptions: {
							type: `bankReferencesName${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `城市 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesCity${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesCity${i}CN`
						},
						createOptions: {
							type: `bankReferencesCity${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `州/省 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesStateOrProvince${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesStateOrProvince${i}CN`
						},
						createOptions: {
							type: `bankReferencesStateOrProvince${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `国家 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesCountry${i}CN`
						},
						createOptions: {
							type: `bankReferencesCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `账户类型 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesTypeOfAccount${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesTypeOfAccount${i}CN`
						},
						createOptions: {
							type: `bankReferencesTypeOfAccount${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `联系人姓名 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesNameOfContact${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesNameOfContact${i}CN`
						},
						createOptions: {
							type: `bankReferencesNameOfContact${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `联络人职衔`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesTitleOfContact${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesTitleOfContact${i}CN`
						},
						createOptions: {
							type: `bankReferencesTitleOfContact${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `联络人电话号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesTelOfContact${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesTelOfContact${i}CN`
						},
						createOptions: {
							type: `bankReferencesTelOfContact${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `联络人传真号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesFaxOfContact${i}CN`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesFaxOfContact${i}CN`
						},
						createOptions: {
							type: `bankReferencesFaxOfContact${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaOtherList(i) {
			return [
				{
					label: `机构名称 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionName${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionName${i}CN`
						},
						createOptions: {
							type: `financialInstitutionName${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `城市 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionCityy${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionCity${i}CN`
						},
						createOptions: {
							type: `financialInstitutionCity${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `州/省 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionStateOrProvince${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionStateOrProvince${i}CN`
						},
						createOptions: {
							type: `financialInstitutionStateOrProvince${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `国家 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionCountry${i}CN`
						},
						createOptions: {
							type: `financialInstitutionCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `关系 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionRelationship${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionRelationship${i}CN`
						},
						createOptions: {
							type: `financialInstitutionRelationship${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `联系人姓名 ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionContactName${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionContactName${i}CN`
						},
						createOptions: {
							type: `financialInstitutionContactName${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `联络人职衔`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionContactTitle${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionContactTitle${i}CN`
						},
						createOptions: {
							type: `financialInstitutionContactTitle${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `联络人电话号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionContactTel${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionContactTel${i}CN`
						},
						createOptions: {
							type: `financialInstitutionContactTel${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `联络人传真号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionContactFax${i}CN`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionContactFax${i}CN`
						},
						createOptions: {
							type: `financialInstitutionContactFax${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
